module.exports = __webpack_public_path__ + "img/default-device.dba92be9.png";